import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("dig-ui-toaster", { bottom: "" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_base_locale_popup = _resolveComponent("base-locale-popup")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass({ 'dark-mode': _ctx.darkMode })
  }, [
    _hoisted_1,
    _createVNode(_component_router_view),
    _createVNode(_component_base_locale_popup)
  ], 2))
}